import { ColumnViewModel } from "../column/column-viewModel";

export class ColumnSort{
    
    constructor() {
        this.state =0;        
    }

    public set noSort(v: boolean) { this._noSort = v; } public get noSort(): boolean { return this._noSort;} private _noSort: boolean;
    public set ascending(v: boolean) { this._ascending = v; } public get ascending(): boolean { return this._ascending;} private _ascending: boolean;
    public set descending(v: boolean) { this._descending = v; } public get descending(): boolean { return this._descending;} private _descending: boolean;
    public set column(v: ColumnViewModel) { this._column = v; } public get column(): ColumnViewModel { return this._column;} private _column: ColumnViewModel;

    private set state(v: number) { 
        this._state = v; 
        this.noSort = this.state==0;
        this.ascending = this.state==1;
        this.descending = this.state==2;
    } private get state(): number { return this._state;} private _state: number;
    
    public Change(){
        this.state = (this.state +1)%3;
    }

    public setNoSort() {
        this.state = 0;
    }

}

export class BooleanColumnSort extends ColumnSort{

}

export class DateColumnSort extends ColumnSort{

}
export class EnumColumnSort extends ColumnSort{

}
export class NumericColumnSort extends ColumnSort{

}
export class StringColumnSort extends ColumnSort{

}